<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition" class="searchArea">
			<div>
				<ScreeCompany
				:allowField="allowField"
				@ScreeCompany="ScreeCompany" />
<!-- 				<el-form-item label="税源地">
				<el-input
				v-model="searchCondition.name"
				placeholder="输入税源地"
				class="item-name"
				clearable
				@input="event_searchChange"
				></el-input>
				</el-form-item>
				<el-form-item label="公司">
				<el-input
				v-model="searchCondition.company_name"
				placeholder="输入公司"
				class="item-name"
				clearable
				@input="event_searchChange"
				></el-input>
				</el-form-item> -->
				<el-form-item label="时间">
				<el-date-picker
				v-model="searchCondition.month"
				type="month"
				placeholder="选择一个月份"
				value-format="yyyy-MM"
				@change="event_searchChange"
				/>
				<!-- <DatePicker @dataSearch="dataSearch" /> -->
				</el-form-item>
			</div>

			<el-button class="btn_export" type="primary" @click="event_export">导出</el-button>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
          v-show="userPermissions.includes('dutypaid_list')"
        >
          <el-table-column
            width="180"
            header_align="center"
            align="center"
            label="个人完税"
          >
            <template slot-scope="scope">
              <span>
                <el-button size="mini" @click="viewButton(scope.row)">查看</el-button>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
	<!-- 添加列弹窗 -->
	<ModalDialog :dialogData="addColumnDialogData" @dialogConfirm="addColumnConfirm" @dialogClose="addColumnDialogClose">
		<template slot="content">
			<p>字段名称</p>
			<el-input style="width: 240px;" v-model="addColumnDialogForm.columnName" placeholder="字段名称"></el-input>
			<p>关联字段</p>
			<el-select
			v-model="addColumnDialogForm.selectColumn"
			class="m-2"
			placeholder="请选择"
			size="large"
			style="width: 240px"
			>
				<el-option
				v-for="item in columns"
				:key="item.value"
				:label="item.title"
				:value="item.value"
				/>
			</el-select>
		</template>
	</ModalDialog>
	<!-- 审核模态框 -->
	<ModalDialog :dialogData="exportDialogData" @dialogConfirm="exportConfirm" @dialogClose="exportDialogClose">
		<template slot="content">
			<el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm">
			<el-form-item label="表名">
			<el-input v-model="exportForm.name" placeholder="请输入表名"></el-input>
			</el-form-item>
			<el-form-item label="字段">
				<el-button @click="event_addColumn">添加列</el-button>
				<el-table :data="[companyList[0]]||companyList" style="width: 100%">
					<el-table-column :key="index" v-for="(item,index) in exportForm.columns" :prop="item.prop" :label="item.label" />
				</el-table>
			</el-form-item>
			</el-form>
		</template>
	</ModalDialog>
    <!-- 审核模态框 -->
     <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 2">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.remark" placeholder="请输入拒绝原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <!-- 办理模态框 -->
    <ModalDialog :dialogData="handleDialogData" @dialogConfirm="handleConfirm" @dialogClose="handleDialogClose">
      <template slot="content">
        <el-form :model="handleRuleForm" ref="handleRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="handleRuleForm.status">
              <el-radio label="2">办理成功</el-radio>
              <el-radio label="3">办理失败</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="handleRuleForm.status == 5">
            <el-input type="textarea" :rows="4" v-model="handleRuleForm.remark" placeholder="请输入办理失败原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import ModalDialog from '@/components/ModalDialog'
import { mapGetters, mapState } from "vuex";
import ScreeCompany from '@/components/ScreeCompany.vue'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ModalDialog,
	ScreeCompany
  },
  data() {
    return {
		addColumnDialogForm:{
		selectColumn:'',
		columnName:''
		},
		addColumnDialogData:{
		visible: false,
		title: '选择列',
		width: '40%',
		},
		exportDialogData:{//导出模态框
		visible: false,
		title: '导出',
		width: '40%',
		},
		exportForm:{
		name:'',
		columns:[
			{
				label:'税源地',
				prop:'channel_name'
			},
			{
				label:'公司',
				prop:'company_name'
			}
		]
		},
		// 允许显示的字段
      allowField: ['companyId', 'settlementId'],
      examineDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {//审核表单数据
        id: '',
        status: '',
        remark: ''
      },
      handleDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      handleRuleForm: {
        id: '',
        status: '',
        remark: ''
      },
      searchCondition: {
		month:''
      },
      companyList: [],
      columns: [
		{
			title: '税源地',
			value: 'channel_name',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '通道标识',
			value: 'yl_bank_name',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '公司',
			value: 'company_name',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '费率',
			value: 'rate',
			header_align: 'center',
			align: 'center',
		},
        {
          title: '充值金额',
          value: 'recharge_money',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '下发金额',
          header_align: 'center',
          align: 'center',
          value: 'withdraw_money',
        },
        {
          title: '小于三万',
          value: 'less_money',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '大于三万',
          value: 'more_money',
          header_align: 'center',
          align: 'center',
        }
      ],
      options: [{
        value: '1',
        label: '办理中'
      },{
        value: '2',
        label: '办理成功'
      }, 
      {
        value: '3',
        label: '办理失败'
      }],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      loadingStaus: true,
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    },
    "handleRuleForm.status": function(val) {
      if(val) {
        this.handleDialogData.loading = false
      }else {
        this.handleDialogData.loading = true
      }
    }
  },
  methods: {
	exportDialogClose(){
	this.exportDialogData.visible = false
	},
	//转换导出数据
	formatJson(jsonData) {
	return jsonData.map(v => {
		let arr = []
		this.exportForm.columns.map(item=>{
			arr.push(v[item.prop])
		})
		return arr
	})
	},
	async exportConfirm(){
	let searchCondition = this.handleSearchCondition();
	let pagingInfo = {
		current_page: 1,
		page_size: 10000
	}
	Object.assign(searchCondition, pagingInfo);
	let { data } = await this.$api.getpersonalTaxList(searchCondition);
	let tHeader = []
	this.exportForm.columns.map(item=>{
		tHeader.push(item.label)
	})
	let exportData = this.formatJson(data)

	import('@/excel/Export2Excel').then(excel => {
	const time = new Date().getTime() + Math.random() * 1000
	let filename = `${this.exportForm.name}${time}`
	excel.export_json_to_excel({
	header: tHeader, //Header Required
	data:exportData, //Specific data Required
	filename: filename, //Optional
	autoWidth: true, //Optional
	bookType: 'xlsx', //Optional
	})
	})
	this.exportDialogClose()
	},
	//确认弹窗
	addColumnConfirm(){
	let obj = {
		label:this.addColumnDialogForm.columnName,
		prop:this.addColumnDialogForm.selectColumn
	}
	this.exportForm.columns.push(obj)
	this.addColumnDialogData.visible = false
	},
	addColumnDialogClose(){
	this.addColumnDialogData.visible = false
	},
	//增加列弹窗打开
    event_addColumn(){
      this.addColumnDialogData.visible = true
      this.addColumnDialogForm.columnName = ''
      this.addColumnDialogForm.selectColumn = ''
	},
	event_export(){
	this.exportDialogData.visible = true
	this.exportForm.columns = [
		{
			label:'税源地',
			prop:'channel_name'
		},
		{
			label:'公司',
			prop:'company_name'
		}
	]
	},
	ScreeCompany(v, name) {
	if(name == 'company') {
		if (v) {
		this.searchCondition.company_id = v
		} else {
		delete this.searchCondition.company_id
		}
		this.init('search')
	}
	if(name == 'settlement') {
		if (v) {
		this.searchCondition.channel_account = v
		} else {
		delete this.searchCondition.channel_account
		}
		this.init('search')
	}
	},
	event_searchChange(e) {
		console.log(e,8888)
		this.init('search')
	},
    //删除 
    async deleteButton(id) {
      let args = {
        id
      }
      let result = await this.$api.individualDelete(args)
      if(result) {
        this.init()
        this.$message.success('删除成功')
      }
    },
    // 响应详情按钮
    async viewButton(row) {
      console.log(row,'结果结果')
      this.$router.push(`/personalTax/detail?company_id=${row.company_id}&channel_account=${row.channel_account}&month=${this.searchCondition.month}&yl_bank=${row.yl_bank}`)
    },
    //个体户审核
    async individualAudit() {
      let result = await this.$api.individualAudit(this.examineRuleForm)
      if(result) {
        this.examineDialogData.visible = false
        this.examineRuleForm = {}
        this.init()
        this.$message.success('审核完成')
      } 
    },
    //个体户办理
    async individualHandle() {
      let result = await this.$api.individualAudit(this.handleRuleForm)
      if(result) {
        this.handleDialogData.visible = false
        this.handleRuleForm = {}
        this.init()
        this.$message.success('办理完成')
      }
    },
    //审核确定模态框
    examineHandleConfirm() {
      this.$refs['examineRuleForm'].validate((valid) => {
        if(valid) {
          this.individualAudit()
        }
      })
    },
    //审核关闭模态框
    examineDialogClose() {
      this.examineDialogData.visible = false
      this.examineRuleForm = {}
    },
    //办理确定模态框
    handleConfirm() {
      this.$refs['handleRuleForm'].validate((valid) => {
        if(valid) {
          this.individualHandle()
        }
      })
    },
    //办理关闭模态框
    handleDialogClose() {
      this.handleDialogData.visible = false
      this.handleRuleForm = {}
    },
    //查询按钮
    searchButton() {
      this.init('search')
    },  
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { pages, data} = await this.$api.getpersonalTaxList(searchCondition);
      this.companyList = data;
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.pagingData.offset = (pages.current_page - 1) * pages.page_size;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id;
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account;
      }
      if (this.searchCondition.month) {
        condition.month = this.searchCondition.month
      }
      return condition;
    },
    //分页
    switchPaging() {
    this.init();
    },
    //审核操作
    examineButton(id) {
      this.examineDialogData.visible = true
      this.examineRuleForm.id = id
    },
    //办理操作
    handleButton (id) {
      this.handleDialogData.visible = true
      this.handleRuleForm.id = id
    }
  },
  mounted() {
	let year = new Date().getFullYear()
	let month = new Date().getMonth()+1
	if(month == 1){
		year--
		month = 12
	}else{
		month-- 
		if(month < 10){
			month = `0${month}`
		}
	}
	this.searchCondition.month = `${year}-${month}`
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.searchArea{
	display: flex;justify-content: space-between;
}
.btn_export{
	height: 34px;
}
/deep/.el-checkbox-group label {
  width: 180px;
}

/deep/.el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/.el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
